import React from 'react';
import { StarIcon } from 'lucide-react';
import { Eyebrow, Section } from './Section';
import { Testimonial } from '../data/testimonials';
interface TestimonialsProps {
  testimonials: Testimonial[];
  eyebrow: string;
  title: string;
  note?: string;
  tone?: 'creme' | 'paper';
  id: string;
}
function Stars() {
  return <div className="flex gap-0.5" aria-label="5 sur 5" data-id="element-232" data-mp="3azt3njzzaphd">
      {[0, 1, 2, 3, 4].map(index => <StarIcon key={index} className="h-3.5 w-3.5 fill-accent text-accent" aria-hidden="true" data-id="element-233" data-mp="36zr015aonlzg" />)}
    </div>;
}
export function Testimonials({
  testimonials,
  eyebrow,
  title,
  note,
  tone = 'paper',
  id
}: TestimonialsProps) {
  return <Section tone={tone} labelledBy={`${id}-title`} data-id="element-234" data-mp="2s2rvxrf1ib9q">
      <div className="md:flex md:items-end md:justify-between md:gap-10" data-id="element-235" data-mp="v9gb9qm8i8qq">
        <div data-id="element-236" data-mp="v8nbj9lp0ji3">
          <Eyebrow data-id="element-237" data-mp="v72jprqrjenx">{eyebrow}</Eyebrow>
          <h2 id={`${id}-title`} className="max-w-2xl font-serif text-3xl font-semibold leading-[1.15] text-graphite md:text-[2.5rem]" data-id="element-238" data-mp="qa3p7836t5p7">
            {title}
          </h2>
        </div>
        {note && <p className="mt-6 max-w-xs text-xs leading-relaxed text-warm md:mt-0 md:text-right" data-id="element-239" data-mp="m6cgpwqb0n1n">
            {note}
          </p>}
      </div>

      <ul className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3" data-id="element-240" data-mp="c6bvg58vjwut">
        {testimonials.map(testimonial => <li key={testimonial.name} className="flex flex-col border border-warm-line bg-creme/60 p-6 md:p-7" data-id="element-241" data-mp="zxh8ydrced1y">
            <Stars data-id="element-242" data-mp="14xluii73xxz1" />
            <blockquote className="mt-5 text-base leading-relaxed text-graphite" data-id="element-243" data-mp="q6wdgz6yton9">
              {testimonial.quote}
            </blockquote>
            <figure className="mt-auto flex items-center gap-4 pt-8" data-id="element-244" data-mp="v4eocv4jmdxw">
              <img src={testimonial.photo} alt={testimonial.alt} className="h-14 w-14 shrink-0 rounded-full border border-warm-line object-cover" width={112} height={112} loading="lazy" data-id="element-245" data-mp="1ius5vrpi4ue8" />
              <figcaption data-id="element-246" data-mp="1siec16d4ypsh">
                <p className="text-sm font-semibold text-graphite" data-id="element-247" data-mp="1sk7k8q3edi2l">
                  {testimonial.name}
                </p>
                <p className="mt-0.5 text-xs leading-relaxed text-warm" data-id="element-248" data-mp="1ofhpx5oe0bjs">
                  {testimonial.role}
                </p>
              </figcaption>
            </figure>
          </li>)}
      </ul>
    </Section>;
}